import { Vue } from 'vue-property-decorator';

export { default as BaseContent } from '@/app/shared/components/base/content.vue';
export { default as BaseDrawer } from '@/app/shared/components/base/drawer.vue';
export { default as BaseLoading } from '@/app/shared/components/base/loading.vue';
export { default as BaseView } from '@/app/shared/components/base/view.vue';
export { default as CardContract } from '@/app/shared/components/cards/contract.vue';
export { default as DialogCancelContract } from '@/app/shared/components/dialogs/cancel-contract.vue';
export { default as DialogCancelContractMarkOff } from '@/app/shared/components/dialogs/cancel-contract-mark-off.vue';
export { default as DialogReactiveContract } from '@/app/shared/components/dialogs/reactivate-contract.vue';
export { default as DialogCertificate } from '@/app/shared/components/dialogs/certificate.vue';
export { default as DialogEndService } from '@/app/shared/components/dialogs/end-service.vue';
export { default as DialogInstallmentDevolutionMarkOff } from '@/app/shared/components/dialogs/installment-devolution-mark-off.vue';
export { default as ListContract } from '@/app/shared/components/lists/contract.vue';
export { default as TabContract } from '@/app/shared/components/tabs/contract.vue';
export { default as DialogConfirmBlacklist } from '@/app/shared/components/dialogs/confirm-blacklist.vue';

Vue.component('BaseContent', () =>
  import('@/app/shared/components/base/content.vue')
);
Vue.component('EmptyState', () =>
  import('@/app/shared/components/base/empty-state.vue')
);
Vue.component('TooltipTextIcon', () =>
  import('@/app/shared/components/base/tooltip-text-icon.vue')
);
